import { PayeeTaxDocumentSharePermission } from "@wingspanhq/payments/dist/interfaces";
import { WSMutationConfig } from "@ws-react-query";
import { useWSMutation } from "../../../query/helpers";
import {
  QUERY_NOTIFICATIONS_NOTIFICATION,
  QUERY_NOTIFICATIONS_NOTIFICATIONS
} from "../../../query/notifications/keys";
import { QUERY_PAYER, QUERY_PAYER_LIST } from "../../../query/payers/keys";
import {
  QUERY_REQUIREMENTS_FULL_LIST,
  QUERY_REQUIREMENTS_LIST
} from "../../../query/requirements/keys";
import { QUERY_PAYER_ROWS } from "../../../query/search/payer/queries/useQueryPayerRows";
import { QUERY_PAYER_ROWS_SUMMARY } from "../../../query/search/payer/queries/useQueryPayerRowsSummary";
import { updatePayer } from "../../../services/payers";
import { WSServiceError } from "../../../utils/serviceHelper";
import { updateTaxVerificationRequirementCaches } from "./updateTaxVerificationRequirementCaches";

export const useMutationSubmit = (config?: WSMutationConfig<void>) => {
  return useWSMutation<any, WSServiceError, string[]>(
    async payerIds => {
      return await Promise.all(
        payerIds.map(payerId =>
          updatePayer(payerId, {
            payeeOwnedData: {
              shareTaxDocument: PayeeTaxDocumentSharePermission.Allow
            }
          })
        )
      );
    },
    {
      dependencies: [
        QUERY_NOTIFICATIONS_NOTIFICATION,
        QUERY_NOTIFICATIONS_NOTIFICATIONS,
        QUERY_PAYER_ROWS,
        QUERY_PAYER,
        QUERY_PAYER_LIST,
        QUERY_PAYER_ROWS_SUMMARY,
        QUERY_REQUIREMENTS_FULL_LIST,
        QUERY_REQUIREMENTS_LIST
      ],
      onSuccess: (result, payerIds, c) => {
        // Optimistically update all cached requirement lists
        updateTaxVerificationRequirementCaches(payerIds);

        // Call user's onSuccess if provided
        config?.onSuccess?.(result, payerIds, c);
      },
      ...config
    }
  );
};
